import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["src", "title"]
const _hoisted_2 = {
  key: 1,
  class: "icon-img icon is-medium"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showSearch && _ctx.showSearch(...args)), ["prevent"])),
    draggable: "true",
    onDragstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDragStart && _ctx.onDragStart(...args))),
    onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
    onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
  }, [
    (_ctx.currentImage)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.currentImage,
          title: _ctx.title
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(_component_ion_icon, {
            class: "is-size-1",
            name: "images-outline"
          })
        ]))
  ], 32))
}